module.exports = __webpack_public_path__ + "static/img/NationalGeographic.ac74caa2.jpg";